module.exports = __webpack_public_path__ + "img/boost.9b75b1d6.jpg";